import Circle from '../../src/legacy/Circle';
export default Circle;
